module.exports = __webpack_public_path__ + "img/20190903145429360截图20190903133934609.318bd106.jpg";